import React from 'react';
import Icon from '../common/Icons';
import '../companies/CompanyListUx.css';

function AnimatedValue({ value, className }) {
  return (
    <strong key={value} className={`${className} co-list-stat__value--tick`}>
      {value}
    </strong>
  );
}

export default function SiteListStats({ stats, id = 'st-list-stats' }) {
  const { total, active, inactive, withPharmacy, central, activePct, repositoryTotal, isFiltered } =
    stats;

  return (
    <section
      id={id}
      className={`co-list-stats ${isFiltered ? 'is-filtered' : ''}`}
      aria-label="Statistiques des sites affichés"
      aria-live="polite"
      aria-atomic="true"
    >
      {isFiltered ? (
        <div className="co-list-stats__banner" role="status">
          <Icon name="filter" size={14} aria-hidden />
          <span>Indicateurs alignés sur les filtres actifs</span>
          <span className="co-list-stats__banner-meta">
            {total} sur {repositoryTotal} au répertoire
          </span>
        </div>
      ) : null}

      <div className="co-list-stats__grid st-list-stats__grid">
        <article className="co-list-stat co-list-stat--primary">
          <span className="co-list-stat__label">Affichés</span>
          <AnimatedValue value={total} className="co-list-stat__value" />
          <span className="co-list-stat__hint">
            {isFiltered ? 'dans la sélection filtrée' : 'sites enregistrés'}
          </span>
        </article>

        <article className="co-list-stat co-list-stat--success">
          <span className="co-list-stat__label">Actifs</span>
          <AnimatedValue value={active} className="co-list-stat__value" />
          <div className="co-list-stat__meter" aria-hidden>
            <span className="co-list-stat__meter-fill" style={{ width: `${activePct}%` }} />
          </div>
          <span className="co-list-stat__hint">{total > 0 ? `${active}/${total}` : '—'}</span>
        </article>

        <article className="co-list-stat co-list-stat--muted">
          <span className="co-list-stat__label">Inactifs</span>
          <AnimatedValue value={inactive} className="co-list-stat__value" />
          <span className="co-list-stat__hint">hors service</span>
        </article>

        <article className="co-list-stat st-list-stat--pharmacy">
          <span className="co-list-stat__label">Pharmacie locale</span>
          <AnimatedValue value={withPharmacy} className="co-list-stat__value" />
          <span className="co-list-stat__hint">
            {central > 0 ? `${central} centrale${central > 1 ? 's' : ''}` : 'sites équipés'}
          </span>
        </article>
      </div>
    </section>
  );
}
